import { range } from 'lodash';
import React, { Component, FC } from 'react';
import moment from 'moment';

import { SelectPrimitive, SelectProps } from '../Select';
import {
  FormikProxy,
  EnhancedComponentProps,
} from '~/components/inputs/FormikProxy';

export type TimePickerSelectProps = SelectProps & {
  format: string;
  onChange: (value: number) => void;
  onBlur: () => void;
  value: number;
  onMenuClose: () => void;
};

interface ExternalProps extends EnhancedComponentProps<number> {
  format: string;
  onMenuClose: () => void;
}

const minutesInADay = 60 * 24;
const timeIntervals = range(0, minutesInADay, 30);

export class TimePickerSelectPrimitive extends Component<
  TimePickerSelectProps
> {
  public static defaultProps = {
    format: 'h:mm A',
    onBlur: () => {},
  };

  public handleChange = (value: number) => {
    this.props.onChange(value);
  };

  public render() {
    const { format, onChange, value, ...props } = this.props;
    const timeOptions = timeIntervals.map(minutes => {
      const time = moment(0)
        .utcOffset(0)
        .add(minutes, 'minutes');
      const inMs = minutes * 60 * 1000;

      return { label: time.format(format), value: inMs };
    });
    const selectedOption = timeOptions.find(option => option.value === value);

    return (
      <SelectPrimitive
        options={timeOptions}
        onChange={this.handleChange}
        value={selectedOption}
        {...props}
      />
    );
  }
}

class TimePickerSelectBase extends Component<TimePickerSelectProps> {
  // We trigger an onBlur event when menu closes to trigger Formik validation
  public handleMenuClose = () => {
    this.props.onBlur();
  };

  public render() {
    return (
      <TimePickerSelectPrimitive
        onMenuClose={this.handleMenuClose}
        {...this.props}
      />
    );
  }
}

const EnhancedTimePickerSelect: FC<ExternalProps> = ({
  field,
  form,
  onChange,
  ...rest
}) => (
  <FormikProxy<number>
    field={field}
    form={form}
    onChange={onChange}
    render={formikProps => (
      <TimePickerSelectBase
        field={field}
        form={form}
        {...rest}
        {...formikProps}
      />
    )}
  />
);

export const TimePickerSelect = EnhancedTimePickerSelect;
try {
    // @ts-ignore
    TimePickerSelectPrimitive.displayName = "TimePickerSelectPrimitive";
    // @ts-ignore
    TimePickerSelectPrimitive.__docgenInfo = { "description": "", "displayName": "TimePickerSelectPrimitive", "props": { "onChange": { "defaultValue": null, "description": "", "name": "onChange", "required": true, "type": { "name": "((value: any) => void) & ((value: number) => void)" } }, "field": { "defaultValue": null, "description": "", "name": "field", "required": true, "type": { "name": "Pick<{ onChange: { (e: ChangeEvent<any>): void; <T = string | ChangeEvent<any>>(field: T): T extends ChangeEvent<any> ? void : (e: string | ChangeEvent<any>) => void; }; onBlur: { ...; }; value: any; name: string; }, \"value\" | \"name\">" } }, "form": { "defaultValue": null, "description": "", "name": "form", "required": true, "type": { "name": "Pick<FormikProps<any>, \"setFieldValue\" | \"setFieldTouched\">" } }, "format": { "defaultValue": { value: "h:mm A" }, "description": "", "name": "format", "required": true, "type": { "name": "string" } }, "onBlur": { "defaultValue": null, "description": "", "name": "onBlur", "required": true, "type": { "name": "() => void" } }, "value": { "defaultValue": null, "description": "", "name": "value", "required": true, "type": { "name": "number" } }, "onMenuClose": { "defaultValue": null, "description": "", "name": "onMenuClose", "required": true, "type": { "name": "() => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/inputs/TimePickerSelect/TimePickerSelect.tsx#TimePickerSelectPrimitive"] = { docgenInfo: TimePickerSelectPrimitive.__docgenInfo, name: "TimePickerSelectPrimitive", path: "src/components/inputs/TimePickerSelect/TimePickerSelect.tsx#TimePickerSelectPrimitive" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    TimePickerSelect.displayName = "TimePickerSelect";
    // @ts-ignore
    TimePickerSelect.__docgenInfo = { "description": "", "displayName": "TimePickerSelect", "props": { "format": { "defaultValue": null, "description": "", "name": "format", "required": true, "type": { "name": "string" } }, "onMenuClose": { "defaultValue": null, "description": "", "name": "onMenuClose", "required": true, "type": { "name": "() => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/inputs/TimePickerSelect/TimePickerSelect.tsx#TimePickerSelect"] = { docgenInfo: TimePickerSelect.__docgenInfo, name: "TimePickerSelect", path: "src/components/inputs/TimePickerSelect/TimePickerSelect.tsx#TimePickerSelect" };
}
catch (__react_docgen_typescript_loader_error) { }